import styled from 'styled-components'
import { Box } from '~/components/Box'
import { SettingsIcon } from '~/components/icons'

export const StyledExchangePage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.bgBase};

  p {
    margin: 0;
  }
`

export const StyledContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const StyledContainer = styled.div`
  position: relative;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  max-width: 1200px;

  ${({ theme }) => theme.media.sm`
    gap: 0;
  `}
`

export const StyledFormContainer = styled.div<{ withActivity: boolean }>`
  display: flex;
  flex-direction: column;
  margin: 68px auto 0;

  ${({ theme, withActivity }) => theme.media.sm`
    width: 100%;
    margin: 72px auto 0;
    padding: 0 15px;
    
    ${withActivity && 'margin-top: 18px;'}
  `}
`

export const StyledExchangeBox = styled.div<{ hide: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  ${({ hide }) => hide && 'display: none;'}
`

export const StyledSettingsBtnContainer = styled.div`
  position: absolute;
  top: -46px;
  right: 44px;
  cursor: pointer;
`

export const StyledSettingsWrapper = styled.span`
  position: relative;
  width: 32px;
  height: 32px;
`

export const StyledIconSettings = styled(SettingsIcon)`
  cursor: pointer;
`

export const StyledBoxContainer = styled(Box)`
  height: 100%;
  width: 100%;
`

export const StyledMainArea = styled.div`
  position: relative;
`

export const StyledMainAreaInner = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: ${({ theme }) => theme.colors.textStrong};
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
`

export const StyledDetailWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 20px;
  color: ${({ theme }) => theme.colors.textCaption};
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
`
